import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.QBooksMatchingPopup.SelectedLineInformation', {
    title: 'Selected line for matching',
});
